/** Состояние интеграции организации с соцсетью — GraphQL enum `IntegrationStatus`. */
export enum IntegrationStatus {
  ACTIVE = 'ACTIVE',
  /** Бот потерял доступ к каналу (бэкенд переводит сюда после отказа Telegram при публикации). */
  DISCONNECTED = 'DISCONNECTED',
}
